import axiosIns from "@/api/axios";
// import axiosIns from "../dummy";

export const GET_ALL_DATA = (args) => {
  return axiosIns.get("/gentagendis", args);
};

export const ADD_DATA = (args) => {
  return axiosIns.post("/users/genta-gendis/create", args);
};

export const UPDATE_DATA = (args) => {
  return axiosIns.put(`/gentagendis/update?id=${args.id}`, args.data);
};

export const DETAIL_DATA = (args) => {
  return axiosIns.put(`/gentagendis/byId?id=${args.id}`);
};

export const DELETE_DATA = (args) => {
  return axiosIns.delete(`/users/genta-gendis/delete?nik=${args}`, { data: {nik: args}});
};
